import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { getIdeaOfTheWeek } from "../../db/news-section-db";
import { IdeaOfTheWeekType } from "@robotical/analytics-gatherer";
import { renderBody } from "../../utils/traverseBody";
import LoadingSpinner from "../../components/LoadingSpinner";

type Props = {
};

export default function IdeaOfTheWeekSection({ }: Props) {
    const [isLoading, setLoading] = useState(true);
    const [newsFeedData, setIdeaOfTheWeekData] = useState<IdeaOfTheWeekType | null>(null);

    useEffect(() => {
        const asyncFunc = async () => {
            setLoading(true);
            const ideaOfTheWeek = await getIdeaOfTheWeek();
            const ideaOfTheWeekArray = Object.values(ideaOfTheWeek);
            const latestIdeaOfTheWeek = ideaOfTheWeekArray[0];
            if (ideaOfTheWeekArray.length) {
                setIdeaOfTheWeekData(latestIdeaOfTheWeek);
            }
            setLoading(false);
        };

        asyncFunc();
    }, []);


    return (
        <div className={styles.ideaOfTheWeekSectionContainer}>
            <div className={styles.ideaOfTheWeekTitle}>Idea of the Week</div>
            <div className={styles.ideaOfTheWeekContentContainer}>
                {isLoading ? <LoadingSpinner /> : newsFeedData && renderBody(newsFeedData, styles)}
            </div>
        </div>
    );
}